import GTMProvider from "@components/GTM/GTMProvider";
import UserProvider from "@context/User/UserContext";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { router } from "./AppRoutes";
import BaseTheme from "./BaseTheme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: 0,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity
    }
  }
});

const App = () => {
  const { i18n } = useTranslation();

  // Update HTML lang attribute when language changes
  useEffect(() => {
    const updateHtmlLang = () => {
      const htmlElement = document.documentElement;
      if (htmlElement) {
        htmlElement.setAttribute("lang", i18n.language);
      }
    };

    // Update on mount and when language changes
    updateHtmlLang();
    i18n.on("languageChanged", updateHtmlLang);

    // Cleanup listener on unmount
    return () => {
      i18n.off("languageChanged", updateHtmlLang);
    };
  }, [i18n]);

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={BaseTheme}>
          <CssBaseline />

          <UserProvider>
            <GTMProvider>
              <RouterProvider router={router} />
            </GTMProvider>
          </UserProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
};

export default App;
